import React from 'react';
import { NextPage } from 'next';
import { RouteContext } from 'hoc/Route';
import { getPath } from 'utils/api';
import { Path, PathsList } from '../../components/Paths';

const Paths: NextPage = (): JSX.Element => {
    const { params } = React.useContext(RouteContext);

    if (params?.id) {
        return <Path />;
    }

    return <PathsList />;
};

Paths.getInitialProps = async ({ res, query }) => {
    // Show 404 if path not found
    if (query && query.id) {
        try {
            await getPath(query.id);
        } catch (err) {
            console.error(err);

            if (res) {
                res.statusCode = err?.response?.status || 404;
            }

            return { err: { statusCode: err?.response?.status || 404 } };
        }
    }

    return {};
};

export default Paths;
